import {
  IconDots,
  IconFullScreen,
  IconInspect,
  IconPower,
  IconPresetColor,
  IconRain,
  IconRainbow,
  IconResetConfig,
  IconResetCamera,
  IconRGB,
  IconInfo,
  IconDesk,
  IconSoundOn,
  IconSoundOff, IconDoorOpen, IconDoorClose
} from "./icons";

const makeID = (prefix = '') => id => `${prefix}${id}`;
const makeActionID = makeID('action_');

export const EFFECT_ID_RAINBOW = 'rainbow';
export const EFFECT_ID_RAIN = 'rain';
export const EFFECT_ID_COLOR_ONE = 'color_1';
export const EFFECT_ID_COLOR_TWO = 'color_2';
export const EFFECT_ID_COLOR_THREE = 'color_3';

export const ACTION_DOTS = makeActionID('dots');
export const ACTION_FULL_SCREEN = makeActionID('full_screen');
export const ACTION_RESET_CONFIG = makeActionID('reset_config');
export const ACTION_RESET_CAMERA = makeActionID('reset_camera');
export const ACTION_RGB = makeActionID('rgb');
export const ACTION_POWER = makeActionID('power');
export const ACTION_OPEN = makeActionID('open');
export const ACTION_INSPECT = makeActionID('inspect');
export const ACTION_CHANGE_BUNDLE = makeActionID('change_bundle');
export const ACTION_CHANGE_SINGLE = makeActionID('change_single');
export const ACTION_STUDIO_MODE = makeActionID('studio_mode');
export const ACTION_CALL_INFO = makeActionID('call_info');
export const ACTION_SOUND = makeActionID('sound_toggle');

export const SYSTEM_ID_CHANGE_BUNDLE = 'action_change_bundle';
export const SYSTEM_ID_CHANGE_SINGLE = 'action_change_single';
export const SYSTEM_ID_RESET_CONFIG = 'action_reset_configuration';
export const SYSTEM_ID_RESET_CAMERA = 'action_reset_camera';
export const SYSTEM_ID_ICUE = 'action_change_ICUE_profile';
export const SYSTEM_ID_TOGGLE_INSPECT = 'action_toggle_inspect';
export const SYSTEM_ID_TOGGLE_POWER = 'action_toggle_PC_power';
export const SYSTEM_ID_TOGGLE_DOOR = 'action_toggle_case_door';
export const SYSTEM_ID_ZOOM = 'zoom';
export const SYSTEM_ID_TOGGLE_DESK_CAMERA = 'action_toggle_desk_camera';
export const SYSTEM_ID_FULL_SCREEN = 'fe_action_full_screen';
export const SYSTEM_ID_RGB = 'fe_action_rgb';
export const SYSTEM_ID_DOTS = 'fe_action_dots';
export const SYSTEM_ID_INFO = 'fe_action_info';
export const SYSTEM_ID_SOUND = 'fe_sound_switch';

export const PRESET_DOTS = {
  id: ACTION_DOTS,
  iconData: {IconComponent: IconDots},
  action: {id: SYSTEM_ID_DOTS},
}
export const PRESET_RAINBOW = {
  text: 'Rainbow',
  id: EFFECT_ID_RAINBOW,
  iconData: {IconComponent: IconRainbow},
  action: {
    id: SYSTEM_ID_ICUE,
    data: 'rainbow',
  },
};
export const PRESET_RAIN = {
  text: 'Rain',
  id: EFFECT_ID_RAIN,
  iconData: {IconComponent: IconRain},
  action: {
    id: SYSTEM_ID_ICUE,
    data: 'rain',
  },
};
export const PRESET_COLOR_ONE = {
  text: 'GOML',
  id: EFFECT_ID_COLOR_ONE,
  iconData: {IconComponent: IconPresetColor, fill: '#3750cf'},
  action: {
    id: SYSTEM_ID_ICUE,
    data: 'color_1',
  },
};
export const PRESET_COLOR_TWO = {
  text: 'Red',
  id: EFFECT_ID_COLOR_TWO,
  iconData: {IconComponent: IconPresetColor, fill: '#cc333d'},
  action: {
    id: SYSTEM_ID_ICUE,
    data: 'color_2',
  },
};
export const PRESET_COLOR_THREE = {
  text: 'Blue',
  id: EFFECT_ID_COLOR_THREE,
  iconData: {IconComponent: IconPresetColor, fill: '#12ebf3'},
  action: {
    id: SYSTEM_ID_ICUE,
    data: 'color_3',
  },
};
export const PRESET_FULL_SCREEN = {
  text: 'Vollbild',
  id: ACTION_FULL_SCREEN,
  iconData: {IconComponent: IconFullScreen},
  action: {id: SYSTEM_ID_FULL_SCREEN},
};
export const PRESET_RESET_CONFIG = {
  text: 'Konfiguration zurücksetzen',
  id: ACTION_RESET_CONFIG,
  iconData: {IconComponent: IconResetConfig},
  action: {id: SYSTEM_ID_RESET_CONFIG},
};
export const PRESET_RESET_CAMERA = {
  text: 'Kamera zurücksetzen',
  id: ACTION_RESET_CAMERA,
  iconData: {IconComponent: IconResetCamera},
  action: {id: SYSTEM_ID_RESET_CAMERA},
};
export const PRESET_RGB = {
  text: 'RGB Beleuchtung',
  id: ACTION_RGB,
  iconData: {IconComponent: IconRGB},
  action: {id: SYSTEM_ID_RGB},
};
export const PRESET_POWER = {
  text: {
    activated: 'PC Power On',
    disabled: 'PC Power Off',
  },
  id: ACTION_POWER,
  iconData: {IconComponent: IconPower},
  action: {id: SYSTEM_ID_TOGGLE_POWER},
};
export const PRESET_OPEN = {
  text: {
    activated: 'Seitenfenster öffnen',
    disabled: 'Seitenfenster schließen',
  },
  id: ACTION_OPEN,
  iconData: {
    IconComponent: IconDoorOpen,
    default: IconDoorOpen,
    disabled: IconDoorClose,
  },
  action: {id: SYSTEM_ID_TOGGLE_DOOR},
};
export const PRESET_INSPECT = {
  text: {
    activated: 'Inspect',
    disabled: 'Inspect-Mode Off',
  },
  id: ACTION_INSPECT,
  iconData: {IconComponent: IconInspect},
  action: {id: SYSTEM_ID_TOGGLE_INSPECT},
};
export const PRESET_INFO = {
  text: 'Hilfe/Steuerung',
  id: ACTION_CALL_INFO,
  iconData: {IconComponent: IconInfo},
  action: {id: SYSTEM_ID_INFO},
}
export const PRESET_STUDIO_MODE = {
  text: 'Tischansicht',
  id: ACTION_STUDIO_MODE,
  iconData: {IconComponent: IconDesk},
  action: {id: SYSTEM_ID_TOGGLE_DESK_CAMERA},
}
export const PRESET_SOUND = {
  text: '',
  id: ACTION_SOUND,
  iconData: {
    IconComponent: IconSoundOn,
    default: IconSoundOn,
    disabled: IconSoundOff,
  },
  action: {id: SYSTEM_ID_SOUND},
}
